export default __webpack_public_path__ + "static/media/ic_company.5c23e8d9.svg";